"use client";
import useAnalyticsActionEvents from "@stadium/services/analytics/hooks/use-action-events";
import { getEventName } from "@stadium/helpers/analytics";
import { useJuneSoComponentContext } from "@stadium/services/june-analytics/component-provider";
import { JuneSoEventPropsType } from "@stadium/services/june-analytics/prop-types.d";
import { ReactNode, useCallback, useMemo } from "react";
import { useJuneSoContext } from "@stadium/services/june-analytics/provider";
import { getEventTargetLocation } from "@stadium/services/june-analytics/helpers";

const defaultObj = {};
const defaultArr = [];

/**
 * @deprecated Use useJuneSoEventTracking instead
 */
export const useJuneSoEventTracker = ({
  services = defaultArr,
  elementPosition = "",
}: {
  services: readonly string[];
  elementPosition?: string;
}) => {
  const { trackEvent: _trackEvent } = useAnalyticsActionEvents(services);
  const { componentName } = useJuneSoComponentContext();
  const { currentUserData } = useJuneSoContext();
  const groupId = currentUserData?.company?.id;
  const companyName = currentUserData?.company?.name;

  const trackEvent = useCallback(
    ({
      eventProperties = defaultObj,
      target = null,
      action = "clicked",
    }: {
      eventProperties?: JuneSoEventPropsType;
      target?: ReactNode | string;
      action?: string;
    }) => {
      if (componentName || elementPosition) {
        return _trackEvent({
          eventName: getEventName({
            targetLocation: getEventTargetLocation({ componentName, elementPosition }),
            target,
            action,
          }),
          eventProperties,
          context: { groupId },
          additionalProps: { companyName },
        });
      }
    },
    [componentName, elementPosition, groupId],
  );

  return useMemo(() => ({ trackEvent }), [trackEvent]);
};
